import { tap, ignoreElements, delay, switchMap, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
// ---- external imports -----

import GameService from '~/services/game.service';
import { 
	gameSelectors,
	financialStatementsSelectors,
	playerHealthActions,
	loadingActions
} from '~/store';
import {
	UI_FETCHING_NETWORK_REQUEST
} from '~/store/ui/actionTypes';
// ---- internal imports ----

import * as actionTypes from '../actionTypes';
import { onCloseBreakevenTutorial } from '../../ui/actions';
// ---- parent imports ----

export const UPDATE_FINANCIAL_STATEMENTS_FIELD_BY_ACTION = {
	[actionTypes.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER] : 'balanceSheet',
	[actionTypes.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER] : 'incomeStatement',
	[actionTypes.FINANCIAL_STATEMENTS_UPDATE_FINANCIAL_RATIOS_FOR_QUARTER] : 'financialRatios',
	[actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_STATEMENTS] :  'hasAttemptedToSubmitFinancialStatements',
	[actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS] : 'hasAttemptedToSubmitFinancialRatios',
}

const saveFinancialStatementsEpic = (action$, state$) => action$.pipe(
	ofType(
		actionTypes.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER,
		actionTypes.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER,
		actionTypes.FINANCIAL_STATEMENTS_UPDATE_FINANCIAL_RATIOS_FOR_QUARTER,

		actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_STATEMENTS,
		actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS,
	),
	tap((action) => {
		saveFinancialStatements(state$.value, action);
	}),
	ignoreElements()
);

async function saveFinancialStatements(state, action) {
	const gameUserId = gameSelectors.getGameId(state);
	const field = UPDATE_FINANCIAL_STATEMENTS_FIELD_BY_ACTION[action.type];
	const quarterNum = action.quarterNum ?? null;
	let result;
	switch(action.type) {
		case actionTypes.FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER:
			result = await GameService.updateFinancialStatementsField(gameUserId, quarterNum, field, action.updatedBalanceSheet);
			break;
		case actionTypes.FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER:
			result = await GameService.updateFinancialStatementsField(gameUserId, quarterNum, field, action.updatedIncomeStatement);
			break;
		case actionTypes.FINANCIAL_STATEMENTS_UPDATE_FINANCIAL_RATIOS_FOR_QUARTER:
			result = await GameService.updateFinancialStatementsField(gameUserId, quarterNum, field, action.updatedFinancialRatios);
			break;
		case actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_STATEMENTS:
			result = await GameService.updateFinancialStatementsField(gameUserId, quarterNum, field, action.hasAttemptedToSubmitFinancialStatements);
			break;
		case actionTypes.FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS:
			result = await GameService.updateFinancialStatementsField(gameUserId, quarterNum, field, action.hasAttemptedToSubmitFinancialRatios);
			break;
	}
}
 

export {
	saveFinancialStatementsEpic,
};
